// Задержка применения ввода, используется в поиске
export const INPUT_CHANGE_WAIT = 330 // ms
